import * as tslib_1 from "tslib";
import showBindPhone from '@ivy/fts/showBindPhone';
import { toItem } from '../../../helper';
import PopupPay from '../../_comps/popupPay.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Toast } from 'mint-ui';
let BuyAlbum = class BuyAlbum extends Vue {
    constructor() {
        super(...arguments);
        this.showPanel = false;
        this.orderType = '';
    }
    wechatPayOver(res) {
        this.$emit('on-wechat-pay', res);
    }
    get from() {
        let from = this.$route.query.from;
        return ['timeline', 'groupmessage', 'singlemessage'].includes(from) ? 'share' : this.$route.query.from;
    }
    findListen(arr = []) {
        let resault = null;
        for (let item of arr) {
            const list = item.list || [];
            let canListen = list.find(au => au.has_access === 1 || au.listen === 1);
            if (canListen) {
                resault = canListen;
                break;
            }
        }
        return resault;
    }
    toItem() {
        let isGroup = this.album.show_type === 'group';
        let data = isGroup ?
            this.findListen(this.album.groups || []) : (this.album.audios || []).find(au => au.has_access === 1 || au.listen === 1);
        let albumId = this.album.id;
        if (!data) {
            return Toast('无可试听的音频');
        }
        console.log('---', data);
        const opt = { data, type: 'audio', from: this.from, bigAlbumId: albumId, memId: this.$route.query.memId };
        toItem(opt);
    }
    async setOrder(type) {
        if (!this.$store.logined.token) {
            return await this.toRelation();
        }
        if (type === 'vip') {
            let from = `${window.location.pathname}${window.location.search}`;
            return this.$router.push({ path: '/vip', query: { from, action: 'callPay' } });
        }
        this.orderType = type;
        this.showPanel = true;
    }
    async toRelation() {
        let res = await showBindPhone(); // 弹出绑定手机号的窗口
        // 绑定成功之后重新登录
        if (res.message === 'ok' || res.user) {
            this.$store.logined = res.logined;
            this.$router.go(0);
        }
    }
};
tslib_1.__decorate([
    Prop()
], BuyAlbum.prototype, "album", void 0);
BuyAlbum = tslib_1.__decorate([
    Component({
        components: { PopupPay }
    })
], BuyAlbum);
export default BuyAlbum;
